import { compose, join, map, defaultTo } from 'ramda'

export const objToString = compose(
  join('\n'),
  map(join(': ')),
  Object.entries,
  defaultTo({})
)
